<template>
	<sf-modal-layout size="large" title="위젯이미지" :show="open" :closeModal="onClose">
		<div class="widget thumbnail modal">
			<sf-card class="card detail">
				<el-row :gutter="24">
					<el-col :span="12">위젯Key </el-col>
					<el-col :span="12">{{ widgetKey }}</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">위젯타이틀 </el-col>
					<el-col :span="12">{{ widgetTitle }}</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">이미지파일ID </el-col>
					<el-col :span="12">{{ widgetTnFileId }}</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">Size변경 </el-col>
					<el-col :span="12">{{ resizable }}</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">Paramter </el-col>
					<el-col :span="12">{{ params }}</el-col>
				</el-row>
				<el-row
					>s
					<el-col :span="12">사용유무 </el-col>
					<el-col :span="12">{{ useYn }}</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">적용갯수 </el-col>
					<el-col :span="12">{{ widgetDivCnt }}</el-col>
				</el-row>
			</sf-card>
			<!-- <sf-card class="card image">{{ this.widgetTnFileId }}</sf-card> -->
			<!-- <dropzone-file-upload /> -->
		</div>
		<template :v-slot="footer">
			<div>
				<!-- <el-button> 취소 </el-button>  -->
				<el-button class="float-right" @click="onConfirm"> 확인 </el-button>
			</div>
		</template>
	</sf-modal-layout>
</template>
<script>
export default {
	props: {
		open: { type: Boolean, default: false },
		widgetKey: { type: String, default: '' },
		widgetTitle: { type: String, default: '' },
		widgetTnFileId: { type: String, default: '' },
		useYn: { type: String, default: '' },
		widgetDivCnt: { type: Number, default: 0 },
		resizable: { type: String, default: '' },
	},
	methods: {
		onClose() {
			this.$emit('closeThumbnailModal');
		},
		onConfirm() {
			this.onClose();
		},
	},
};
</script>
<style >
.card.detail {
	overflow: hidden;
}
.widget.thumbnail.modal {
	position: static;
	display: flex;
	flex-direction: column !important;
	height: 400px;
}
.float-right {
	float: right;
}
</style>